import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, MTabsInpage, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LocationConfig from './locationConfig';
import LocationConfigCrud from './locationConfigCrud';


export default function LocationPage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const { renameTab } = useContext(NavigateContext);
    const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);
    const location = useLocation();

    const [menu, setMenu] = useState(1);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'location');

    const sessionKeys = ['menu', 'selectedLocation', 'refresh'];

    //============================================================================================================
    // EFFECT
    // Rename tab when language changes
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return; // If no selected tab, do nothing
        renameTab(String(selectedTab), t('Locations'));
    }, [t, selectedTab]);

    //============================================================================================================
    // EFFECT
    // Updates the session ID when the selected tab changes
    //============================================================================================================
    useEffect(() => {
        const newId = M_State.find(obj => obj.key === 'selectedTab')?.value; // Get the new session ID from Redux
        if (newId && newId !== id) {
            setId(newId); // Update local state with the new session ID if it has changed
            getSessionStorageData(newId);
        }
    }, [M_State, id]);


    //============================================================================================================
    // Gets session storage data based on the session ID
    //============================================================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const session = M_State.find(obj => obj.key === sessionID)?.value;
        if (session) {
            const m = session.find(x => x.key === 'menu')?.value;
            const loc = session.find(x => x.key === 'selectedLocation')?.value;
            const ref = session.find(x => x.key === 'refresh')?.value;
            if (m) setMenu(m);
            if (loc) setSelectedLocation(loc);
            if (ref !== undefined) setRefresh(ref);
        }
        ctx.setIsLoad(false);
    };

    //============================================================================================================
    // EFFECT
    // Sets the session storage data based on the current state
    //============================================================================================================
    useEffect(() => {
        getSessionStorageData(id); // Fetch session data when the tab ID changes
        //setRefresh(r => !r); // Toggle refresh to ensure data reloads
    }, [location.pathname]);


    ////============================================================================================================
    // EFFECT
    // Persists the session storage data based on the current state
    //============================================================================================================
    useEffect(() => {
        const values = { menu, selectedLocation, refresh }; // Current state values to persist
        const sessionData = sessionKeys.map(k => ({ key: k, value: values[k] })); // Map session keys to their current values
        dispatch(M_StateActions.addM_State({ key: id, value: sessionData })); // Dispatch action to save state in Redux
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, menu, selectedLocation, refresh]);

    return (
        <div className="divGlobalSettings">
            <div>
                <Routes>
                    <Route index element={
                        <LocationConfig // Main location configuration component with the dynamic table
                            roles={roles}
                            onCreateTab={onCreateTab}
                            toastMessages={toastMessages}
                            selectedLocation={selectedLocation}
                            setSelectedLocation={setSelectedLocation}
                            refresh={refresh}
                            setRefresh={setRefresh}
                        />
                    } />
                    <Route path='locationConfigCrud' element={
                        <LocationConfigCrud // Location configuration CRUD component
                            handleTabClose={handleTabClose}
                            toastMessages={toastMessages}
                        />
                    } />
                </Routes>
            </div>
        </div>
    );
}
